import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc.module';
import { MultipleResultsPageRoutingModule } from './multiple-results-routing.module';
import { MultipleResultsPageComponent } from './multiple-results.page';

@NgModule({
  declarations: [MultipleResultsPageComponent],
  imports: [FormsModule, IonicModule, MultipleResultsPageRoutingModule, MiscModule, CommonModule, MiscModule]
})
export class MultipleResultsPageModule {}
